import VPageStudentUpdateRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageStudentUpdateRecord', VPageStudentUpdateRecord),
};
